import { defineStore } from 'pinia';
import api from '../api/index.js';

export const useDatatablesStore = defineStore('datatables', {
  state: () => ({
    tables: [],
    currentTable: null,
    rows: [],
    rowsMeta: { total: 0, current_page: 1, total_pages: 1 },
    loading: false,
    error: null,
  }),

  actions: {
    async fetchTables(params = {}) {
      this.loading = true;
      try {
        const { data } = await api.getTables(params);
        this.tables = data.datatables;
      } finally {
        this.loading = false;
      }
    },

    async fetchTable(slug) {
      this.loading = true;
      try {
        const { data } = await api.getTable(slug);
        this.currentTable = data;
      } finally {
        this.loading = false;
      }
    },

    async createTable(tableData) {
      const { data } = await api.createTable(tableData);
      this.tables.unshift(data);
      return data;
    },

    async updateTable(slug, tableData) {
      const { data } = await api.updateTable(slug, tableData);
      this.currentTable = data;
      const idx = this.tables.findIndex(t => t.slug === slug);
      if (idx !== -1) this.tables[idx] = data;
      return data;
    },

    async deleteTable(slug) {
      await api.deleteTable(slug);
      this.tables = this.tables.filter(t => t.slug !== slug);
    },

    async fetchRows(slug, params = {}) {
      this.loading = true;
      try {
        const { data } = await api.getRows(slug, params);
        this.rows = data.rows;
        this.rowsMeta = data.meta;
      } finally {
        this.loading = false;
      }
    },

    async createRow(slug, rowData) {
      const { data } = await api.createRow(slug, rowData);
      this.rows.unshift(data);
      if (this.currentTable) this.currentTable.rows_count += 1;
      return data;
    },

    async updateRow(slug, rowId, rowData) {
      const { data } = await api.updateRow(slug, rowId, rowData);
      const idx = this.rows.findIndex(r => r.id === rowId);
      if (idx !== -1) this.rows[idx] = data;
      return data;
    },

    async deleteRow(slug, rowId) {
      await api.deleteRow(slug, rowId);
      this.rows = this.rows.filter(r => r.id !== rowId);
      if (this.currentTable) this.currentTable.rows_count -= 1;
    },
  },
});
